exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrap[data-v-67af31d0]{margin-top:30px;padding:0 20px}.table[data-v-67af31d0]{margin-top:30px}.user-input[data-v-67af31d0]{width:200px}.over-path[data-v-67af31d0]{display:-webkit-box;-webkit-line-clamp:4;overflow:hidden}", ""]);

// exports
